// hooks/useAuth.js
import { useState } from 'react';
import api from '../api';

export const useAuth = () => {
    // is_authenticated 쿠키 확인
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return document.cookie.includes('is_authenticated=true');
    });

    const logout = async () => {
        try {
            await api.post('/users/auth/logout/');
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            setIsAuthenticated(false);
            // 메인 도메인 로그인 페이지로
            window.location.href = process.env.REACT_APP_REDIRECT_URI || '/login';
        }
    };

    // 토큰 갱신은 api.js의 인터셉터에서 자동 처리
    
    return { 
        isAuthenticated,
        logout
    };
};

export default useAuth;